export default {
  props: {
    instagram: Boolean,
    defaultInstagramPlacement: Boolean,
  },
  data() {
    return {
      localInstagram: this.instagram === null ? this.defaultInstagramPlacement : this.instagram,
    };
  },
  watch: {
    localInstagram: {
      immediate: true,
      handler(value) {
        this.$emit('update:instagram', value);
      },
    },
    instagram(value) {
      this.localInstagram = value;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/placement-selector/PlacementSelector.js